<template>
	<div id="d_help">
		<title>APP下载(APP Download)</title>
		<div class="d-background">
			<div>
				<div class="top_bg">
					<a href="https://app.hooply.net/video_list" ><img class="to_see_video" src="https://xhlzn-test.oss-cn-hangzhou.aliyuncs.com/hlaj/5%402x.png" alt=""></a>
					<img class="font_one" src="https://xhlzn-test.oss-cn-hangzhou.aliyuncs.com/hlaj/%E7%82%B9%E5%87%BB%E8%A7%82%E7%9C%8B%E8%A7%86%E9%A2%91%E6%95%99%E7%A8%8B%402x.png" alt="">
						<img class="font_two" src="https://xhlzn-test.oss-cn-hangzhou.aliyuncs.com/hlaj/%E9%B8%BF%E5%88%A9%EF%BC%8C%E8%AE%A9%E5%AE%B6%E6%9B%B4%E5%AE%89%E5%85%A8%402x.png" alt="">
				</div>
				
				<div>
					<div style="width:57%;">
						<img src="/static/img/qr@2x0912.png"/>
						<span>扫描二维码安装</span>
						<p>Scan QR code installation</p>
					</div>
					<div style="width: 100%;">
						<mt-button @click="download" v-if="isiOS">
							<i class="iconfont icon-pingguo"></i>
							<span>&thinsp;iOS版下载</span>
							<p>&thinsp;IOS version download</p>
						</mt-button>
						<mt-button @click="download" v-if="!isiOS">
							<i class="iconfont icon-anzhuo"></i>
							<span>&thinsp;Android版下载</span>
							<p>&thinsp;Android version download</p>
						</mt-button>
                        <mt-button @click="google" v-if="!isiOS" style="background-color: rgb(103, 194, 58);">
							<!-- <i class="iconfont icon-anzhuo"></i> -->
							<span style="display:flex;align-items: center;justify-content: center;">&thinsp;<img style="width:20px;margin-right:5px;" src="../assets/new_btn.svg" alt="">google用户下载</span>
							<p>&thinsp;Download for foreign users</p>
						</mt-button>
						<div style="height:16px;padding-top: 6px;">
							<span style="float: left;">大小(size)：{{(download_data.f_size/1048576).toFixed(2)}}Mb</span>
							<span style="float: right;">版本(version)：{{download_data.version_name}}</span>
						</div>
					</div>
					<span>更新时间(update time)：{{download_data.now}}</span>
				</div>
				
			</div>
		</div>
	</div>
</template>
<script>
	import { Button,Toast } from 'mint-ui';
export default {
  data() {
            return {
          qrurl:'',
          isiOS:null,
          download_data:{},
          id:'',
          download_flag:false,

            }
  },

  computed: {
            
  },

  beforeCreate() {
            if(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)=="micromessenger"){
          window.location.href='http://a.app.qq.com/o/simple.jsp?pkgname=net.hooply.xhlzn'
            }
  },

  mounted() {
            let u=navigator.userAgent,self=this
            self.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            self.$store.dispatch('post',{u:'/appup/check_up',d:{app_type:self.isiOS?1:0}}).then(function(res){
                if(res.err==0){
              //时间转换
              self.id = res.data.id;
              let now=Date.parse(new Date())/1000-res.data.add_time
              if(now/86400>1){
                  now=~~(now/86400)+'天前(days before)'
              }else if(now/3600>1){
                  now=~~(now/3600)+'小时前(hours before)'
              }else if(now/60>1){
                  now=~~(now/60)+'分钟前(minute before)'
              }else  if(now/60<1){
                  now='刚刚(just now)'
              }else{
                  now='未知时间(Unknown time)'
              }
              res.data.now=now
              //赋值
              self.download_data=res.data
              return
                }
                Toast({
              message: res.data,
          });
            })
  },

  methods: {
            download() {
                let self=this
                if(self.download_flag){
                    return;
                }
                self.download_flag = true;
                self.$store.dispatch('post',{u:'/appup/download_count',d:{id:self.id}}).then(function(res){
                    if(res.err==0){
                        self.download_flag = false;
                            if(self.isiOS){
                            window.location.href=self.download_data.file
                                }else{
                            window.open('http:'+self.download_data.file);
                        }
                        return
                    }
                     self.download_flag = false;
                    Toast({
                        message: res.data,
                    });
                })
                   
            },
            google(){
                window.open('https://play.google.com/store/apps/details?id=com.lock.hhlock'); 
            }
  }
};
</script>

<style scoped>
	.d-background>div>div.top_bg{
		display:block;
		width:100%;
		height:300px;	
		background:url('https://xhlzn-test.oss-cn-hangzhou.aliyuncs.com/hlaj/new_wx_d_bg.png') no-repeat center;
		background-size: auto 100%;
		margin-bottom:20px;
		padding-top:40px;
		box-sizing:border-box;
	}
	.d-background>div>div.top_bg .to_see_video{
		width:26%;
		margin:0 auto;
		margin-bottom:40px;
	}
	.d-background>div>div.top_bg .font_one{
		width:60%;
		margin:0 auto;
		margin-bottom:10px;
	}
	.d-background>div>div.top_bg .font_two{
		width:40%;
		margin:0 auto;
	}
	
</style>
<style>
	#d_help .mint-button{
		height:50px !important; 
	}	
	#d_help .mint-button--normal{
		padding:0px 0px !important; 
	}
</style>


// WEBPACK FOOTER //
// src/views/download.vue